var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tech-icon"},[_c('cms-image',{attrs:{"src":_vm.icon,"base":{format: 'webp'}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }